import { RouteObject } from 'react-router-dom';
import { BaseRoute } from './BaseRoute';

const routes: RouteObject[] = [
    BaseRoute
];

export default routes;
